const RESIZE_MESSAGE = 'df-embed-board:resize';
const REQUEST_RESIZE_MESSAGE = 'df-embed-board:request-resize';

// Reports content height to the host page, where embed-board.js resizes the iframe to fit
(() => {
  const parent = window.parent;

  if (parent === window) {
    return;
  }

  // The host resizes the iframe a frame or more after the content changes, which makes
  // the document briefly scrollable. It always grows to fit, so scrolling is never needed.
  document.documentElement.style.overflow = 'hidden';

  const postHeight = () => {
    const height = Math.ceil(document.documentElement.getBoundingClientRect().height);
    parent.postMessage({ type: RESIZE_MESSAGE, height }, '*');
  };

  new ResizeObserver(postHeight).observe(document.documentElement);
  window.addEventListener('message', (event) => {
    const { source, data } = event;

    if (source !== parent || data?.type !== REQUEST_RESIZE_MESSAGE) {
      return;
    }

    postHeight();
  });
})();
